import api from './api';

export const getOrganisation = async () => {
    return api.request({
        method: 'GET',
        url: '/organisations'
    });
};
